import debug from 'debug';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-filter-group]';
const PLUGIN_NAME = 'FilterPanel';

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "plugin--filter-panel" */ './filter-panel'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});

    $(document).on('filter-groups-loaded', function(){
        $(ELEMENT_SELECTOR).each(function() {
            const element = this;
            System.import(
                /* webpackChunkName: "plugin--filter-panel" */ './filter-panel'
            ).then((module) => {
                plugin(PLUGIN_NAME, module.default);
                $(element)[PLUGIN_NAME]();
            });
        });
    });
});



// WEBPACK FOOTER //
// ./client/src/core/components/filter-panel/index.js